import $ from 'jquery';
import Keyboard from './keyboard';
/*

Creates no focus on click events, but focuses when tabs

*/

const $html = $('html');
const focusClass = 'no-focus';
const focusActiveClass = 'focus-active';
/**
 * Tab Event
 * @param  {jQuery} html - html element
 * @param  {event} evt - key event
 */
const tabEventHandler = (html, evt) => {
  if (Keyboard.parseKey(evt) === 'TAB' || Keyboard.parseKey(evt) === 'SHIFT_TAB') {
    html.removeClass(focusClass);
    html.addClass(focusActiveClass);
  }
};

const clickEventHandler = (html) => {
  html.addClass(focusClass);
  html.removeClass(focusActiveClass);
};

const noFocus = () => {
  $html.addClass(focusClass);
  $html.on('mousedown.noFocus', evt => clickEventHandler($html, evt));
  $html.on('keyup.noFocus', evt => tabEventHandler($html, evt));
};

export default noFocus;



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/no-focus.js